$(document).ready(() => {
    const PAGE_LENGTH = 10;

    let positionFilter = 'all';
    let gamesTypeFilter = 'all';
    let teamFilter = 'all';
    let displayStart = 0;
    let order = [[5, 'desc']];

    const currentUrl = TRNMNT_helpers.parseUrl();
    const $playerPositionFilter = $('#playerPositionFilter li');
    const $gameTypeFilter = $('#gameTypeFilter');
    const $teamFilter = $('#teamFilter');

    if (currentUrl.params) {
        if (currentUrl.params.tpspf) {
            $playerPositionFilter.find('button').removeClass('active');
            $playerPositionFilter.find(`button[data-position=${currentUrl.params.tpspf}]`).addClass('active');
            positionFilter = currentUrl.params.tpspf;
        }
        if (currentUrl.params.tpsgtf) {
            $gameTypeFilter.val(currentUrl.params.tpsgtf);
            gamesTypeFilter = currentUrl.params.tpsgtf;
        }
        if (currentUrl.params.tpstf) {
            $teamFilter.val(currentUrl.params.tpstf);
            teamFilter = currentUrl.params.tpstf;
        }
        if (currentUrl.params.tpsds) {
            displayStart = currentUrl.params.tpsds;
        }
        if (currentUrl.params.tpsoc && currentUrl.params.tpsod) {
            order = [[currentUrl.params.tpsoc, currentUrl.params.tpsod]];
        }
    }
    // console.log(currentUrl);

    const columns = TRNMNT_helpers.playerTableColumns(() => {
        return positionFilter;
    }, positionFilter === 'goalie');

    const tableColumns = PLAYERS_SHORT_STATS
            ? [
                columns.index, //Порядковый 0
                columns.number, //Номер игрока 1
                columns.player, //Аватарка 2
                columns.position, //Имя и команда 3
                columns.games,//GP 4

                columns.points,//P 5
                columns.goals,//G 6
                columns.assists,//A 7

                columns.wins,//W 22
                columns.loses,// L 23
                columns.goals_against,// GA 26
            ]
            : [
                columns.index, //Порядковый 0
                columns.number, //Номер игрока 1
                columns.player, //Аватарка 2
                columns.position, //Имя и команда 3
                columns.games,//GP 4

                columns.points,//P 5
                columns.goals,//G 6
                columns.assists,//A 7
                columns.plus_minus,//+/- 8
                columns.shots,//S 9
                columns.shots_percent,//S% 10
                columns.faceoff_percent,//FO% 11
                columns.passes_percent,//P% 12
                columns.takeaways,//TA 13
                columns.interceptions,//INT 14
                columns.giveaways,//TA 15
                columns.blocked_shots,//BS 16
                columns.power_play_goals,//PPG 17
                columns.shorthanded_goals,//SHG 18
                columns.penalty_minutes,//PIM 19
                columns.game_winning_goals,//GWG 20
                columns.hits,//Hits 21

                columns.wins,//W 22
                columns.loses,// L 23
                columns.saves_percent,// SV% 24
                columns.saves,// Svs 25
                columns.goals_against,// GA 26
                columns.goal_against_per_game,// GAA 27
                columns.shootouts,// SO 28
            ];

    const $table = $('#tournamentPlayers')
        // .on('processing.dt', function (e, settings, processing) {
        //     $('#tournamentPlayers_processing')
        //         .addClass('bg-dark')
        //         .css('display', processing ? 'block' : 'none')
        //         .html('Загружаются данные...');
        // })
        .DataTable({
            language: {
                url: '/dataTables.ru.json'
            },
            // scrollX: true,
            pageLength: PAGE_LENGTH,
            lengthChange: false,
            layout: {
                bottomEnd: {
                    paging: {
                        firstLast: false,
                    },
                },
            },
            info: false,
            // processing: true,
            serverSide: true,
            autoWidth: false,
            ajax: {
                url: PLAYERS_URL,
                data: function (d) {
                    if (positionFilter !== 'all') {
                        d.position = positionFilter;
                    }
                    if (teamFilter !== 'all') {
                        d.team_id = teamFilter;
                    }
                    d.tournament_id = TOURNAMENT_ID;
                    if (gamesTypeFilter !== 'all') {
                        d.games_type = gamesTypeFilter;
                    }
                },
            },
            displayStart: displayStart,
            order: order,
            search: {
                return: true,
            },
            paging: true,
            searching: false,
            dataSrc: 'data',
            columns: tableColumns,
            createdRow(row) {
                $(row).addClass("stat-row stat-row2");
            },
            initComplete: (settings, json) => {
                $('div.dataTables_filter input').addClass('form-control-dark');
            },
        });

    $table.on('page.dt', function () {
        const info = $table.page.info();
        const displayStart = info.page * PAGE_LENGTH;
        TRNMNT_helpers.insertURLQueryParam('tpsds', displayStart);

        $([document.documentElement, document.body]).animate({
            scrollTop: $('#tournamentPlayers').offset().top - 160
        }, 0);
    });

    $table.on('order.dt', function () {
        // This will show: "Ordering on column 1 (asc)", for example
        const order = $table.order();
        TRNMNT_helpers.insertURLQueryParam('tpsoc', order[0][0]);
        TRNMNT_helpers.insertURLQueryParam('tpsod', order[0][1]);
        TRNMNT_helpers.insertURLQueryParam('tpsds', 0);
    });

    $playerPositionFilter.on('click', event => {
        event.preventDefault();
        positionFilter = $(event.target).data('position');
        console.log('positionFilter = ' + positionFilter);
        const isGoalie = positionFilter === 'goalie';

        TRNMNT_helpers.insertURLQueryParam('tpspf', positionFilter);
        TRNMNT_helpers.insertURLQueryParam('tpsds', 0);
        TRNMNT_helpers.insertURLQueryParam('tpsoc', 5);
        TRNMNT_helpers.insertURLQueryParam('tpsod', 'desc');

        const fieldColumns = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
        for (const index of fieldColumns) {
            $table.column(index).visible(!isGoalie);
        }
        const goalieColumns = [22, 23, 24, 25, 26, 27, 28]
        for (const index of goalieColumns) {
            $table.column(index).visible(isGoalie);
        }

        $table.order([[isGoalie ? 22 : 5, 'desc']]).rows().remove().draw();
    });

    $gameTypeFilter.on('change', event => {
        event.preventDefault();
        gamesTypeFilter = $(event.target).val();
        displayStart = 0;

        TRNMNT_helpers.insertURLQueryParam('tpsgtf', gamesTypeFilter);
        TRNMNT_helpers.insertURLQueryParam('tpsds', 0);
        TRNMNT_helpers.insertURLQueryParam('tpsoc', 5);
        TRNMNT_helpers.insertURLQueryParam('tpsod', 'desc');

        $table.rows().remove().draw();
    });

    $teamFilter.on('change', event => {
        event.preventDefault();
        teamFilter = $(event.target).val();
        displayStart = 0;

        TRNMNT_helpers.insertURLQueryParam('tpstf', teamFilter);
        TRNMNT_helpers.insertURLQueryParam('tpsds', 0);
        TRNMNT_helpers.insertURLQueryParam('tpsoc', 5);
        TRNMNT_helpers.insertURLQueryParam('tpsod', 'desc');

        $table.rows().remove().draw();
    })
});
